import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6d5b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "shop-purchase",
  style: {"min-height":"700px"}
}
const _hoisted_2 = { class: "form-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_5 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-content",
  style: {"margin-top":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("label", null, "同梱配送ルール"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999","font-size":"12px","line-height":"1.5","margin-top":"6px"} }, " ※自動発注時に、配送先住所・受取人が同一である場合、API TikTok注文をまとめて発注します。注文の合計金額が2000元を超える場合、複数の注文に分かれる場合があります。 ")
    ])
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ON（オン） ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" OFF（オフ） ")
const _hoisted_9 = {
  class: "form-content",
  style: {"margin-top":"20px"}
}
const _hoisted_10 = { class: "first" }
const _hoisted_11 = { class: "second" }
const _hoisted_12 = {
  key: 2,
  class: "tips"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"8px"} }, [
  /*#__PURE__*/_createTextVNode(" ※ご注意ください：複数倉庫出荷機能を利用すると、ご注文が在庫状況に応じて複数の倉庫から分割発送される場合があります。 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"700"} }, "その際、発送ごとに送料が発生するため、単一倉庫からの発送に比べて、合計送料が高くなる可能性があります。")
], -1))
const _hoisted_15 = {
  key: 0,
  class: "agreeBox"
}
const _hoisted_16 = ["onClickCapture"]
const _hoisted_17 = { class: "foot" }

import { t } from '@/plugins/i18n'
import { ref, computed, nextTick, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getShopPurchase, updateShopPurchase } from '@/apis/usercenter'
import { useGlobal } from '@/util/useLoading'
import useEdited from '@/util/useEdited'
import { purchaseCfg, purchaseUpt } from '@/apis/setup'
import { ElMessage } from 'element-plus'
import { isD2C, useSite2Station, isJpPurchase, isJA } from '@/store'
import { ShopType, Term } from '@/common/const'
import { getEffectTermByType } from '@/apis/login'
import TermModal from '@/components/termModal/index.vue'
import { request } from '@/config/request/interceptors'
import { ShopPurchaseRespDTO } from '@/service/customer'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const api = useGlobal(purchaseCfg)
const apiAutoCreateOrderType = ref()
const purchaseInfo = ref<ShopPurchaseRespDTO>()
const curshop = computed(() => store.getters.shopInfo)
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK)
const changeWareHouseDelivery = (e) => {
  if (e) {
    model.deliveryType = 'PRIORITY_CN'
  } else {
    model.deliveryType = isTiktok.value ? 'ONLY_JP' : 'ONLY_CN'
  }
}

const agreed = ref(true)
// 协议
const termModalRef = ref()
const term = ref({ fileUrl: '' })

const catTerm = async () => {
  const res = await getEffectTermByType({
    stationCode: useSite2Station(),
    type: Term.mutiWareHouse
  })
  term.value = res.data[0]
  // 等待props更新后，在open
  nextTick(termModalRef.value.open)
}

const agreeCallback = () => {
  agreed.value = true
  termModalRef.value.close()
}

const getInfo = async () => {
  const config = await request.customer.shop.getShopPurchase({ customerShopId: curshop.value.customerShopId }).then(res => res.data)
  purchaseInfo.value = config
  model.apiAutoCreateOrderType = config?.apiAutoCreateOrderType
  model.allowMutiWareHouseDelivery = config?.allowMutiWareHouseDelivery
  model.deliveryType = config?.deliveryType
  model.allowApiOrderMerge = config?.allowApiOrderMerge ?? false
  clear()
}
getInfo()
const [model, update, clear, reset] = useEdited({
  apiAutoCreateOrderType: '',
  allowMutiWareHouseDelivery: false,
  allowApiOrderMerge: false,
  deliveryType: 'ONLY_CN'
}, () => {
  request.customer.customer.shopUpdateShopPurchase({
    ...purchaseInfo.value,
    ...model,
    updateChannel: 1
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      clear()
    }
  })
})
const handle = (index: any) => { model.apiAutoCreateOrderType = index }

const save = () => {
  if (model.allowMutiWareHouseDelivery && !agreed.value) {
    return ElMessage.error(t('请先勾选协议'))
  }
  update()
}

const isMergeOrderWhiteShop = ref(false)

onMounted(() => {
  request.customer.customer.shopIsMergeOrderWhiteShop({
    customerShopId: store.getters.curShop
  }).then((res) => {
    isMergeOrderWhiteShop.value = res.data!
  })
})


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", {
          innerHTML: _unref(t)('当自动下单的商品不满足最小起订量，且有“一件购买”价时').split('\n').map(v => `<label>${v}</label>`).join('<br/>')
        }, null, 8, _hoisted_3)
      ]),
      _createVNode(_component_el_radio_group, {
        "model-value": _unref(model).apiAutoCreateOrderType
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_radio, {
              label: 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handle(1))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("每次询问")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_radio, {
              label: 2,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handle(2))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("不询问，自动下单成功（以“一件购买”价）")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      (isMergeOrderWhiteShop.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_6,
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(model).allowApiOrderMerge,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).allowApiOrderMerge) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: true,
                  class: "radioBox"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: false,
                  class: "radioBox"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isJA)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", null, _toDisplayString(_unref(t)('库存发货优先级设定')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(model).allowMutiWareHouseDelivery,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).allowMutiWareHouseDelivery) = $event)),
                  onChange: changeWareHouseDelivery
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: true,
                      class: "radioBox"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("允许多仓发库存")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: false,
                      class: "radioBox"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("不允许多仓发库存")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  (!_unref(model).allowMutiWareHouseDelivery)
                    ? (_openBlock(), _createBlock(_component_el_radio_group, {
                        key: 0,
                        modelValue: _unref(model).deliveryType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).deliveryType) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_unref(isTiktok))
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: "ONLY_JP"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('仅从日本仓发库存')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_radio, { label: "ONLY_CN" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(isTiktok) ? _unref(t)('仅从中国仓发库存') : _unref(t)('仅从中国仓发库存，库存不足走采购从中国仓发')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_radio_group, {
                        key: 1,
                        modelValue: _unref(model).deliveryType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(model).deliveryType) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, {
                            label: "PRIORITY_JP",
                            class: "radioBox"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('日本仓库优先，不足再取中国仓库存')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, {
                            label: "PRIORITY_CN",
                            class: "radioBox"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('中国仓库优先，不足再取日本仓库存')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])),
                  (_unref(model).allowMutiWareHouseDelivery)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", {
                          innerHTML: _unref(isTiktok) ?
                _unref(t)(`如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，tiktok店铺库存不足不走采购`, {
                  X: _unref(model).deliveryType === 'PRIORITY_JP' ? '日本倉庫' : '中国倉庫',
                  Y: _unref(model).deliveryType === 'PRIORITY_JP' ? '中国倉庫' : '日本倉庫',
                }) :
                _unref(t)(_unref(isJpPurchase)() ? '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，当库存不足时，我们将根据商品的原产国采购并补货至对应的目的地仓库后再发货。' : '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，库存不足走中国采购', {
                  X: _unref(model).deliveryType === 'PRIORITY_JP' ? '日本倉庫' : '中国倉庫',
                  Y: _unref(model).deliveryType === 'PRIORITY_JP' ? '中国倉庫' : '日本倉庫',
                })
                        }, null, 8, _hoisted_13),
                        _hoisted_14
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_unref(model).allowMutiWareHouseDelivery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_el_checkbox, {
                      style: { '--el-color-primary': '#000' },
                      modelValue: agreed.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agreed).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", {
                      class: "agreement",
                      onClickCapture: _withModifiers(catTerm, ["stop"])
                    }, _toDisplayString(_unref(t)('多仓发货协议')), 41, _hoisted_16),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('同意开通')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModalRef'] = _value
        termModalRef.value = _value
      },
      title: _unref(t)('多仓发货协议'),
      fileUrl: term.value?.fileUrl,
      disableBtn: true,
      timer: true,
      ondisAgree: agreeCallback
    }, null, 8, ["title", "fileUrl"])
  ]))
}
}

})